import axios from "axios"
import { debounce } from "debounce"
import { Fragment, useCallback, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import NumberFormat from 'react-number-format'
import { ErrorModal } from "."

const DeleteUserForm = ({ busDrivers }) => {
    const [form, setForm] = useState({ icNo: '' })
    const [errorDisplay, setErrorDisplay] = useState()
    const [showSubmitBtn, setShowSubmitBtn] = useState(false)
    const [phoneNumberDisplay, setPhoneNumberDisplay] = useState()
    const [icNoDisplay, setICNoDisplay] = useState()
    const [nameDisplay, setNameDisplay] = useState()
    const [isActive, setIsActive] = useState()
    const [errors, setErrors] = useState({})

    const [errorMessage, setErrorMessage] = useState()
    const [showErrorModal, setShowErrorModal] = useState(false)
    
    const handleShowErrorModal = () => setShowErrorModal(!showErrorModal);

    const { REACT_APP_API_BACKEND_URL } = process.env;
    
    const searchUser = debounce(form => {
        if (form === '') {
            setErrorDisplay('')
            setPhoneNumberDisplay('')
            setICNoDisplay('')
            setNameDisplay('')
            setIsActive('')
            setShowSubmitBtn(false)
        } else {
            if (busDrivers.length > 0) {
                const filteredBusDriver = busDrivers.filter(item => { return item.nric === form })
                
                if (filteredBusDriver.length !== 0) {
                    const filteredPhoneNo = filteredBusDriver[0].contact_number
                    const filteredICNo = filteredBusDriver[0].nric
                    const filteredName = filteredBusDriver[0].fullname
                    const filteredIsActive = filteredBusDriver[0].is_active

                    if (filteredIsActive === true) {
                        setErrorDisplay('')
                        setPhoneNumberDisplay(filteredPhoneNo)
                        setICNoDisplay(filteredICNo)
                        setNameDisplay(filteredName)
                        setIsActive(filteredIsActive)
                        setShowSubmitBtn(true)
                    } else {
                        setErrorDisplay('User has already been deleted')
                        setPhoneNumberDisplay('')
                        setICNoDisplay('')
                        setNameDisplay('')
                        setIsActive('')
                    }
                } else {
                    setErrorDisplay('User does not exist')
                    setPhoneNumberDisplay('')
                    setICNoDisplay('')
                    setNameDisplay('')
                    setIsActive('')
                }
            }
        }
        // axios.post(url, {
        //     name: form
        // }, { 
        //     headers: { 'content-type': 'application/json' }
        // })
        // .then(result => {
        //     if (result.data.UserAttributes) {
        //         const filteredPhoneNo = result.data.UserAttributes.filter(item => { return item.Name === 'phone_number' })
        //         const filteredICNo = result.data.UserAttributes.filter(item => { return item.Name === 'custom:icNumber' })
        //         const filteredName = result.data.UserAttributes.filter(item => { return item.Name === 'name' })

        //         if (filteredPhoneNo[0]) {
        //             const phoneNumber = filteredPhoneNo[0].Value
        //             const icNo = filteredICNo[0].Value
        //             const name = filteredName[0].Value

        //             phoneNumber && setPhoneNumberDisplay(phoneNumber) 
        //             icNo && setICNoDisplay(icNo)
        //             name && setNameDisplay(name)
        //         } else {
        //             setPhoneNumberDisplay('User does not has a phone number')
        //         }
        //     } else {
        //         setPhoneNumberDisplay('User does not exist')
        //     }
        // })
        // .catch(error => { 
        //     if (JSON.stringify(error.message) === 'Network Error') {
        //         alert('Please check your internet connection!');
        //     } else {
        //         console.log(error)
        //     }
        // });
    }, 1000)

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
          // Check and see if errors exist, and remove them from the error object:
        if ( !!errors[field] ) setErrors({
            ...errors,
            [field]: null
        })
    }

    const findFormErrors = () => {
        const { icNo } = form
        const newErrors = {}

        // // phone number error
        // if (phoneNo && !isValidPhoneNumber(form.phoneNo)) newErrors.phoneNo = 'Invalid phone number!'

        return newErrors
    }
    
    const deleteUser = () => {
        const url = '../../delete_user.php'
        axios.post(url, {
            phoneNo: phoneNumberDisplay
        }, { 
            headers: { 'content-type': 'application/json' }
        })
        .then(result => {
            // console.log(result)
        })
        .catch(error => {
            console.log(error)
        })
    }

    const postToAPI = (form) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/busdriver/deletebusdriver';

        const busDriverDetails = {
            nric: form.icNo,
            is_active: false,
        }

        axios.post(url, busDriverDetails)
        .then(res => {
            setForm({ icNo: '' })
            setErrorDisplay('')
            setPhoneNumberDisplay('')
            setICNoDisplay('')
            setNameDisplay('')
            setIsActive('')
            const successResponse = (isActive === true) && (res.data.Result.message.includes("Successful Updated."))
            const invalidResponse = res.data.Result.message.includes("Invalid Request.")
            const notDeletable = (isActive === false)
            
            const message = successResponse ? 
            ("User has been successfully deleted!") :
            invalidResponse ? 
            "Invalid user/User does not exist." : 
            notDeletable ? 
            "User has already been deleted."
            : "System has encountered an error."
            
            if (successResponse) {
                deleteUser()
            }
            setErrorMessage(message)
            setShowErrorModal(!showErrorModal)
        })
        .catch(err => {
            setForm({ icNo: '' })
            setErrorDisplay('')
            setPhoneNumberDisplay('')
            setICNoDisplay('')
            setNameDisplay('')
            setIsActive('')
            if (err.toJSON().message === 'Network Error') {
                alert('Please check your internet connection!');
            } else {
                console.log(err)
            }
        })
    }

    const handleSearch = useCallback(value => searchUser(value), [])

    const onSubmit = (e) => {
        e.preventDefault();

        const newErrors = form && findFormErrors();
        // Conditional logic:
        if (Object.keys(newErrors).length > 0) {
          // We got errors!
            setErrors(newErrors)
        } else {
          // No errors! Put any logic here for the form submission!
            postToAPI(form)
            setForm({ icNo: '' })
            setPhoneNumberDisplay('')
        }
    };

    const handleICChange = (values) => {
        const { value } = values;
        // const formattedValue = 123456-10-1234
        // const value = 123456101234
        
        handleSearch(value)
        setField('icNo', value)
    }
    
    return (
        <Fragment>
            <Form style={{margin: '20px 50px'}} onSubmit={onSubmit}>
                <h4 className='mt-5 mb-4 fw-bold'>Delete Bus Driver Form</h4>
                <Form.Group as={Row} className='mb-3'>
                    <Form.Label className='fw-bold' column sm='4'>
                        IC Number
                    </Form.Label>
                    <Col sm='6'>
                        <NumberFormat
                            placeholder='Enter IC Number'
                            format='######-##-####'
                            mask='_'
                            value={form.icNo}
                            onValueChange={handleICChange}
                            className={`${errors.icNo ? 'form-control is-invalid' : 'form-control'}`}
                            required
                        />
                        {/* <Form.Control 
                            type='text' 
                            placeholder='Enter IC Number' 
                            value={form.icNo}
                            onChange={(e) => {setField('icNo', e.target.value); handleSearch(e.target.value)}}
                            isInvalid={ !!errors.icNo }
                            required
                        /> */}
                        { errorDisplay && <div style={{marginTop: '5px'}}>{errorDisplay}</div>}
                        {
                            icNoDisplay && 
                            <Fragment>
                                <div style={{marginTop: '5px'}}>Name: {nameDisplay}</div>
                                <div>IC Number: {icNoDisplay}</div>
                                <div>Phone number: {phoneNumberDisplay}</div>
                            </Fragment>
                        }
                        <Form.Control.Feedback type='invalid'>
                            { errors.icNo }
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>
                { showSubmitBtn &&
                    <Button as="input" type="submit" value="Submit" />
                }
            </Form>
            {
                showErrorModal &&
                <ErrorModal message={errorMessage} show={showErrorModal} handleClose={handleShowErrorModal} />
            }
        </Fragment>
    )
}

export default DeleteUserForm
